import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  toastr.success(context.$t('booking.detail.booking_successfully_updated'));
  context.loading = false;
};

// When the request fails
const failed = (error, context) => {
  context.loading = false;
  context.showToasterError(error);
};

export default (booking, context) => {
  return Vue.$http.put('/bookings/' + booking.id, booking)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/booking/updateBooking.js